import React, { useEffect, useState } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  CharacteristicFeature, 
  RollableTable
} from "@dndModels";

import StringBox from "@components/input/strings/StringBox";
import RollableTableInput from "@dndComponents/other/RollableTableInput";
import SelectObjectBox from "@components/input/selects/SelectObjectBoxSimple";
import CheckBox from "@components/input/CheckBox";

interface Props {
  obj: CharacteristicFeature;
  onChange: (changed: CharacteristicFeature) => void; 
  disabled?: boolean;
}

// export interface State { 
//   obj: CharacteristicFeature,
//   reloading: boolean;
// }

// class old extends Component<Props, State> {
//   public static defaultProps = {
//     disabled: false
//   };
//   constructor(props: Props) {
//     super(props);
//     this.state = {
//       obj: props.obj,
//       reloading: false
//     };
//   }

//   componentDidMount() {
//   }

//   render() {
//     return (
//       <Grid container spacing={0} direction="row">
//         <Grid item xs={12}>
//           <CheckBox 
//             name="Show in Source Name"
//             value={this.state.obj.show_in_source_name} 
//             onChange={(value: boolean) => {
//               const obj = this.state.obj;
//               obj.show_in_source_name = value;
//               this.setState({ obj }, () => {
//                 this.props.onChange(obj);
//               });
//             }} 
//           />
//         </Grid>
//         { this.state.obj.show_in_source_name &&
//           <Grid item xs={12}>
//             <CheckBox 
//               name="Replace Source Name"
//               value={this.state.obj.replace_source_name} 
//               onChange={(value: boolean) => {
//                 const obj = this.state.obj;
//                 obj.replace_source_name = value;
//                 this.setState({ obj }, () => {
//                   this.props.onChange(obj);
//                 });
//               }} 
//             />
//           </Grid>
//         }
//         <Grid item xs={4}>
//           <StringBox
//             name="Header 1"
//             value={this.state.obj.header1}
//             onBlur={(changed: string) => {
//               const obj = this.state.obj;
//               obj.header1 = changed;
//               this.setState({ obj }, () => {
//                 this.props.onChange(obj);
//               });
//             }}
//           />
//         </Grid>
//         <Grid item xs={4}>
//           <StringBox
//             name="Header 2"
//             value={this.state.obj.header2}
//             onBlur={(changed: string) => {
//               const obj = this.state.obj;
//               obj.header2 = changed;
//               this.setState({ obj }, () => {
//                 this.props.onChange(obj);
//               });
//             }}
//           />
//         </Grid>
//         <Grid item xs={4}>
//           { !this.state.reloading &&
//             <SelectObjectBox
//               name="Rollable Table"
//               system="dandd"
//               data_type="rollable_table"
//               extra_options={["New"]}
//               value={this.state.obj.rollable_table_id}
//               onChange={(changed: string) => {
//                 const obj = this.state.obj;
//                 obj.rollable_table_id = changed;
//                 this.setState({ obj }, () => {
//                   this.props.onChange(obj);
//                 });
//               }}
//             />
//           }
//         </Grid>
//         <Grid item xs={12}>
//           <RollableTableInput 
//             rollable_table_id={this.state.obj.rollable_table_id}
//             onChange={(changed: RollableTable) => {
//               const obj = this.state.obj;
//               if (obj.rollable_table_id !== changed._id) {
//                 obj.rollable_table_id = changed._id;
//                 this.setState({ obj, reloading: true }, () => {
//                   this.props.onChange(obj);
//                   this.setState({ reloading: false });
//                 });
//               }
//             }}
//           />
//         </Grid>
//       </Grid>
//     );
//   }
// }
export default function CharacteristicFeatureInput({ 
  obj,
  onChange,
  disabled = false 
}: Props) {
  const [reloading, setReloading] = useState(false);

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading]);

  return (
    <Grid container spacing={0} direction="row">
      <Grid
        size={{
          xs: 12
        }}>
        <CheckBox 
          name="Show in Source Name"
          value={obj.show_in_source_name} 
          onChange={(value: boolean) => {
            const new_obj = obj;
            new_obj.show_in_source_name = value;
            onChange(new_obj);
            setReloading(true);
          }} 
        />
      </Grid>
      { obj.show_in_source_name &&
        <Grid
          size={{
            xs: 12
          }}>
          <CheckBox 
            name="Replace Source Name"
            value={obj.replace_source_name} 
            onChange={(value: boolean) => {
              const new_obj = obj;
              new_obj.replace_source_name = value;
              onChange(new_obj);
              setReloading(true);
            }} 
          />
        </Grid>
      }
      <Grid
        size={{
          xs: 4
        }}>
        <StringBox
          name="Header 1"
          value={obj.header1}
          onBlur={(changed: string) => {
            const new_obj = obj;
            new_obj.header1 = changed;
            onChange(new_obj);
            setReloading(true);
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 4
        }}>
        <StringBox
          name="Header 2"
          value={obj.header2}
          onBlur={(changed: string) => {
            const new_obj = obj;
            new_obj.header2 = changed;
            onChange(new_obj);
            setReloading(true);
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 4
        }}>
        { !reloading &&
          <SelectObjectBox
            name="Rollable Table"
            data_type="rollable_table"
            extra_options={["New"]}
            value={obj.rollable_table_id}
            onChange={(changed: string) => {
              const new_obj = obj;
              new_obj.rollable_table_id = changed;
              onChange(new_obj);
              setReloading(true);
            }}
          />
        }
      </Grid>
      <Grid
        size={{
          xs: 12
        }}>
        <RollableTableInput 
          rollable_table_id={obj.rollable_table_id}
          onChange={(changed: RollableTable) => {
            const new_obj = obj;
            if (new_obj.rollable_table_id !== changed._id) {
              new_obj.rollable_table_id = changed._id;
              onChange(new_obj);
              setReloading(true);
            }
          }}
        />
      </Grid>
    </Grid>
  );
}
